(() => {
  if (window.sapHomeHeroLoaded) return;
  window.sapHomeHeroLoaded = true;
  const setups = new Map();
  const init = root => root.querySelectorAll('[data-sap-kit-hero]').forEach(hero => {
    if (setups.has(hero)) return;
    const track = hero.querySelector('[data-home-track]');
    const slides = [...hero.querySelectorAll('[data-home-slide]')];
    const dots = [...hero.querySelectorAll('[data-home-dot]')];
    const pause = hero.querySelector('[data-home-pause]');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const abort = new AbortController();
    let active = 0, timer, frame, stopped = false;
    const on = (node,type,fn) => node.addEventListener(type,fn,{signal:abort.signal});
    const mark = index => {
      active = index;
      slides.forEach((slide,i) => { slide.inert = i !== active; });
      dots.forEach((dot,i) => { if (i === active) dot.setAttribute('aria-current','true'); else dot.removeAttribute('aria-current'); });
    };
    const stop = () => { stopped = true; clearInterval(timer); pause?.setAttribute('aria-pressed','true'); };
    const play = () => { stopped = false; pause?.setAttribute('aria-pressed','false'); start(); };
    const offer = () => { if (pause) pause.hidden = motion.matches || slides.length < 2; };
    const go = index => track.scrollTo({left: index * track.clientWidth,behavior: motion.matches ? 'instant' : 'smooth'});
    const start = () => {
      clearInterval(timer);
      if (!stopped && !motion.matches && slides.length > 1) timer = setInterval(() => {
        if (!document.hidden && hero.checkVisibility()) go((active + 1) % slides.length);
      },7000);
    };
    dots.forEach((dot,i) => on(dot,'click',() => { stop(); go(i); }));
    if (pause) on(pause,'click',() => { if (stopped) play(); else stop(); });
    on(hero,'pointerdown',event => { if (!pause?.contains(event.target)) stop(); });
    on(hero,'focusin',event => { if (!pause?.contains(event.target)) stop(); });
    on(track,'scroll',() => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => mark(Math.min(slides.length - 1,Math.round(track.scrollLeft / track.clientWidth))));
    });
    on(motion,'change',() => { offer(); start(); });
    const resize = new ResizeObserver(() => track.scrollTo({left: active * track.clientWidth,behavior:'instant'}));
    resize.observe(track);
    on(document,'shopify:block:select',event => {
      const index = slides.findIndex(slide => slide.contains(event.target));
      if (index >= 0) { stop(); go(index); }
    });
    offer();mark(0);start();
    setups.set(hero,() => { clearInterval(timer);cancelAnimationFrame(frame);resize.disconnect();abort.abort(); });
  });
  init(document);
  document.addEventListener('shopify:section:load',event => init(event.target));
  document.addEventListener('shopify:section:unload',event => {
    setups.forEach((dispose,hero) => { if (event.target.contains(hero)) { dispose();setups.delete(hero); } });
  });
})();
